module.exports = __webpack_public_path__ + "static/media/user.c184d9b1.png";